$(document).on('click', '.slide-item__link-open-tab', function (e) {
    e.preventDefault();

    let activeHref = $(this).attr('href');
    let activeHandle = activeHref.replace('#', '');

    openCurrentTabpanelByLink(activeHandle);
    linkScrollToAnchor(activeHref, 300);
});

function linkScrollToAnchor(hash, speed) {
    let headerHeight = $('header.header').height();
    if ($(window).width() > 600) {
        headerHeight = headerHeight + 50;
    }
    $('html, body').animate({scrollTop: $(`${hash}`).offset().top - headerHeight }, 300);
}

function openCurrentTabpanelByLink(element) {
    const tabLink = $(`.tabs__link[aria-controls=${element}]`);
    if (tabLink.length > 0) {
        tabLink[0].click();
    }
}